import {CssBaseline, MetrikaProvider, Notifications, ThemeProvider} from '@logistics-frontend/blocks'
import {ThemeProviderv2} from '@logistics-frontend/blocks/theme'
import {I18nProvider} from '@logistics-frontend/core/i18n'
import {ErrorBoundary, RumObservableRoot, RumTimeMark, sendRumTimeMark} from '@logistics-frontend/modules/rum'
import {applyPolyfills} from '@logistics-frontend/polyfills'
import React, {StrictMode} from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'

import {config} from './config'
import {i18n} from './i18n'
import Routes from './Routes'
import createStore from './store'

sendRumTimeMark(RumTimeMark.BEFORE_JS_FRAMEWORK_INIT)

const store = createStore()

const App: React.FC = () => (
  <ThemeProviderv2 dir={config.dir} locale={config.lang}>
    <ThemeProvider>
      <ErrorBoundary i18n={i18n}>
        <CssBaseline />
        <I18nProvider t={i18n}>
          <Provider store={store}>
            <MetrikaProvider yandexID={config.yaMetrikaID}>
              <RumObservableRoot>
                <Notifications>
                  <Routes />
                </Notifications>
              </RumObservableRoot>
            </MetrikaProvider>
          </Provider>
        </I18nProvider>
      </ErrorBoundary>
    </ThemeProvider>
  </ThemeProviderv2>
)

applyPolyfills().then(() =>
  ReactDOM.render(<StrictMode children={<App />} />, document.getElementById('root'), () =>
    sendRumTimeMark(RumTimeMark.REACT_INITED),
  ),
)

sendRumTimeMark(RumTimeMark.JS_FRAMEWORK_INITED)
